import { DOMAIN } from "../../../../var_env."
import { RequestResponsePattern } from "../../../../types/Request"
import { postApi } from "../../../../utils/requestApi"
import { setRequestRemoveData, setRequestRemoveLoading } from "../Reducers/LinksTutoriaisReducer"

export default async function removeItem(dispatch: Function, data: any) {
    try {
        dispatch(setRequestRemoveLoading())
        const response: RequestResponsePattern<any> = await postApi({
            endpoint: `${DOMAIN}/LinksTutoriais/item/remove`,
            data,
        })
        if (response && !response.flagErro) {
            dispatch(setRequestRemoveData(response))
        } else throw new Error(response?.listaMensagens?.[0] ?? 'Erro na requisição')
    } catch (error: any) {
        console.log(error)
    }
}
